import styled from 'styled-components';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: relative;
	transition: opacity 0.3s ease;

	&.container-enter {
		opacity: 0;
	}

	&.container-enter-active,
	&.container-enter-done,
	&.container-exit {
		opacity: 1;
	}

	&.container-exit-active {
		opacity: 0;
	}
`;

const StyledMenu = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 20px;
	width: 100%;
	padding: 20px 40px 20px;
`;

const StyledMenuLeft = styled.div`
	flex: 1;
	min-width: 0;
	display: flex;
	align-items: center;

	& > * {
		flex: 1;
		min-width: 0;
	}
`;

const StyledMenuTabsWrapper = styled.div`
	flex: 0 1 auto;
	max-width: 100%;
	min-width: 0;
	display: flex;
	overflow-x: auto;
	overflow-y: hidden;
	gap: 20px;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledMenuDonateContainer = styled.div`
	display: grid;
	grid-template-columns: auto 40px;
	align-items: center;
	height: 40px;
`;

const StyledMenuDonateCount = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 0 10px;
	height: 40px;
	background-color: rgba(31, 128, 52, 0.25);
	border: 1px solid #1f8034;
	border-radius: 5px 0px 0px 5px;

	${Text} {
		font-weight: 700;
		font-size: 16px;
		color: #ffffff;
	}
`;

const StyledMenuDonateButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 40px;
	height: 40px;
	background-color: #1f8034;
	border-radius: 0px 5px 5px 0px;
	transition: background-color 0.3s ease;
	cursor: pointer;

	img {
		width: 10px;
		height: 10px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}
`;

const StyledCasesContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 20px;
	width: 100%;
	height: 721px;
	margin: 0 auto;
	padding: 0 40px 40px 40px;
	overflow-y: scroll;

	&::-webkit-scrollbar {
		display: none;
	}

	& > div {
		width: 360px;
	}
`;

const StyledMenuRightContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;

	${Divider} {
		height: 40px;
		opacity: 0.1;
	}
`;

const StyledMenuButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 16px;
		height: 16px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledCount = styled.div`
	width: 16px;
	height: 16px;
	background-color: #ff3d3d;
	border-radius: 16px;
	display: flex;
	align-items: center;
	justify-content: center;

	${Text} {
		font-style: italic;
		font-weight: 700;
		font-size: 12px;
		color: #ffffff;
		opacity: 1;
	}
`;

export {
	StyledCasesContainer,
	StyledContainer,
	StyledCount,
	StyledMenu,
	StyledMenuButtonContent,
	StyledMenuDonateButton,
	StyledMenuDonateContainer,
	StyledMenuDonateCount,
	StyledMenuLeft,
	StyledMenuRightContainer,
	StyledMenuTabsWrapper,
};
